import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { countryCodeToFlag } from "./phoneFlag";

// Reliable cross-platform flag rendering. Pulls a tiny PNG from
// flagcdn.com keyed by ISO-2 country code. Falls back to the
// regional-indicator emoji if the image fails (e.g. offline), or to
// null if there's no usable code at all. Windows + Chrome don't
// render regional-indicator emojis as flags out-of-the-box, which is
// why we go to a real image first.
const CountryFlag = ({ iso, width = 20, title }) => {
  const [imgFailed, setImgFailed] = useState(false);
  if (!iso || iso.length !== 2) return null;
  const code = iso.toLowerCase();

  if (imgFailed) {
    const emoji = countryCodeToFlag(iso);
    if (!emoji) return null;
    return (
      <Box
        as="span"
        title={title || iso.toUpperCase()}
        lineHeight="1"
        fontSize={`${width * 0.85}px`}
      >
        {emoji}
      </Box>
    );
  }

  return (
    <Box
      as="img"
      src={`https://flagcdn.com/w20/${code}.png`}
      srcSet={`https://flagcdn.com/w40/${code}.png 2x`}
      alt={title || iso.toUpperCase()}
      title={title || iso.toUpperCase()}
      width={`${width}px`}
      height="auto"
      borderRadius="2px"
      display="inline-block"
      verticalAlign="middle"
      onError={() => setImgFailed(true)}
    />
  );
};

export default CountryFlag;
